import { render, staticRenderFns } from "./Koulutus.vue?vue&type=template&id=4f314702&"
import script from "./Koulutus.vue?vue&type=script&lang=js&"
export * from "./Koulutus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports